export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  }
};

export const CUSTOM_DATE_FORMATS_WITH_TIME = {
  parse: {
    dateInput: ['DD/MM/YYYY hh:mm A', 'YYYY-MM-DDThh:mm']
  },
  display: {
    dateInput: 'DD/MM/YYYY hh:mm A',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
    enableMeridian: true,
  }
};
